import React from 'react';
import { Link } from 'react-router-dom';
import { Receipt, Zap } from 'lucide-react';
import PosV2SessionMagPicker from './PosV2SessionMagPicker';
import { POS_V2_MODES } from './posV2Utils';

const PosV2Header = ({
  sessionMag,
  onSessionMagChange,
  cartCount,
  vendeur,
  caisseOpen,
  activeMode,
  onModeChange,
  healthPhase,
  onOpenTickets,
  posV2Preferred,
  onTogglePreferred,
}) => (
  <header className="border-b border-white/10 bg-[#151820] px-3 sm:px-4 py-2 flex flex-wrap items-center gap-2 sm:gap-3 justify-between">
    <div className="flex items-center gap-3 min-w-0">
      <Zap className="text-red-500 shrink-0" size={22} />
      <div>
        <h1 className="text-base font-bold tracking-tight text-white">POS V2</h1>
        <p className="text-[10px] text-gray-400 truncate">{vendeur || '—'} · session {sessionMag}</p>
      </div>
    </div>

    <nav className="flex gap-1 order-3 lg:order-2 w-full lg:w-auto overflow-x-auto pb-1 lg:pb-0 scrollbar-thin">
      {POS_V2_MODES.map((m) => (
        <button
          key={m.id}
          type="button"
          onClick={() => onModeChange(m.id)}
          className={`min-h-[44px] px-3 sm:px-4 rounded-lg text-sm font-semibold transition shrink-0 ${
            activeMode === m.id ? 'bg-red-600 text-white shadow-lg shadow-red-900/30' : 'bg-white/10 text-gray-300 hover:bg-white/15'
          }`}
        >
          {m.label}
        </button>
      ))}
    </nav>

    <div className="flex items-center gap-1.5 sm:gap-2 text-xs order-2 lg:order-3 ml-auto lg:ml-0 flex-wrap justify-end">
      {onOpenTickets && (
        <button
          type="button"
          onClick={onOpenTickets}
          className="px-2 py-1 rounded bg-white/10 text-gray-300 hover:bg-white/15 flex items-center gap-1"
        >
          <Receipt size={12} /> Tickets
        </button>
      )}
      <PosV2SessionMagPicker
        sessionMag={sessionMag}
        onChange={onSessionMagChange}
        cartCount={cartCount}
      />
      <span className={`px-2 py-1 rounded text-[10px] ${caisseOpen ? 'bg-green-900/50 text-green-300' : 'bg-red-900/50 text-red-300'}`}>
        {caisseOpen ? 'Caisse ouverte' : 'Caisse fermée'}
      </span>
      {/* Étiquette technique « Phase M3 » (jalon de développement POS V2) retirée à la demande de la direction — 2026-09-09 */}
      {onTogglePreferred && (
        <button
          type="button"
          onClick={onTogglePreferred}
          className={`hidden sm:inline px-2 py-1 rounded border text-[10px] ${
            posV2Preferred ? 'border-emerald-500/50 text-emerald-300 bg-emerald-950/30' : 'border-white/15 text-gray-400'
          }`}
          title="Ouvrir POS V2 par défaut au lieu de /pos"
        >
          V2 défaut {posV2Preferred ? '✓' : ''}
        </button>
      )}
      <Link to="/pos" className="text-gray-400 hover:text-white underline hidden sm:inline text-[10px]">/pos</Link>
    </div>
  </header>
);

export default PosV2Header;
